import axios from "axios";

export const chatAxios = axios.create();

chatAxios.interceptors.request.use(async (request) => {
  // const controller = new AbortController();

  // const verifyUser = async () => {
  //   try {
  //     await axios.post("/api/v1/user", {
  //       data: {
  //         mode: import.meta.env.MODE,
  //       },
  //       withCredentials: true,
  //       signal: controller.signal,
  //     });
  //   } catch (error) {
  //     window.location.href =
  //       import.meta.env.MODE !== "prod"
  //         ? encodeURI(
  //             `https://staging.clo-set.com/account/signin?returnUrl=${window.location.href}`,
  //           )
  //         : encodeURI(
  //             `https://style.clo-set.com/account/signin?returnUrl=${window.location.href}`,
  //           );

  //     return Promise.reject(new Error("Invalid User"));
  //   }
  // };

  // console.log(Cookies.get("test_jwt_token"));
  // console.log(Cookies.get("test_crt"));

  // if (Cookies.get("test_jwt_token") === undefined && Cookies.get("test_crt")) {
  //   await verifyUser();
  // }

  return request;
});

// Response interceptor for API calls
chatAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    // if (error.response && error.response.status === 401) {
    //   // Direct browser redirect - only do this if you MUST leave the app
    //   const returnUrl = encodeURIComponent(window.location.href);
    //   if (import.meta.env.MODE === "prod") {
    //     window.location.href = `https://style.clo-set.com/account/signin?returnUrl=${returnUrl}`;
    //   } else {
    //     window.location.href = `https://staging.clo-set.com/account/signin?returnUrl=${returnUrl}`;
    //   }
    // }

    // CRITICAL: You must return the error so the .catch() in your
    // createUserSlice actually catches it!
    return Promise.reject(error);
  },
);
